/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestFindingDeleted,
    RequestFindingDeletedFromJSON,
    RequestFindingDeletedFromJSONTyped,
    RequestFindingDeletedToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface RequestFindingDeletedResponse
 */
export interface RequestFindingDeletedResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof RequestFindingDeletedResponse
     */
    msg: string;
    /**
     * 
     * @type {RequestFindingDeleted}
     * @memberof RequestFindingDeletedResponse
     */
    entry: RequestFindingDeleted;
}

export function RequestFindingDeletedResponseFromJSON(json: any): RequestFindingDeletedResponse {
    return RequestFindingDeletedResponseFromJSONTyped(json, false);
}

export function RequestFindingDeletedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFindingDeletedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': RequestFindingDeletedFromJSON(json['entry']),
    };
}

export function RequestFindingDeletedResponseToJSON(value?: RequestFindingDeletedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': RequestFindingDeletedToJSON(value.entry),
    };
}


